import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BUSINESS_NAME, BUSINESS_DESCRIPTION, EMAIL, } from "@/businessInfo/business";
import HeroSection from "./components/HeroSection";
import ImpactStats from "./components/ImpactStats";
import ProgramsCarousel from "./components/ProgramsCarousel";
import CallToActionBanner from "./components/CallToActionBanner";
import MissionSection from "./components/MissionSection";
import PartnerSpotlight from "./components/PartnerSpotlight";
const missionStatement = "Life Missions International advances compassionate service, education, and sustainable development throughout Washington, D.C. We mobilize neighbors, donors, and mission-driven partners to expand food access, housing stability, community revitalization, and legal advocacy. Our work centers human dignity and equips families with long-term pathways to thrive.";
const focusAreas = [
    {
        title: "Food Security & Holiday Outreach",
        description: "Fueling weekly food distributions, the Weekend Backpack Program, and seasonal holiday baskets that serve more than 1,900 neighbors every year.",
    },
    {
        title: "Housing Stability & Counseling",
        description: "Coordinating with trusted housing counselors to provide transitional housing, renter protections, and supportive services for families navigating critical moments.",
    },
    {
        title: "Economic Mobility & Community Revitalization",
        description: "Accelerating small business assistance, corridor improvements, neighborhood stewardship teams, and collaborative development projects that strengthen Ward 4.",
    },
];
const impactStats = [
    {
        value: "1,900+",
        label: "Families served annually",
        description: "Sustained through weekly food distributions and the Weekend Backpack Program throughout the school year.",
    },
    {
        value: "250+",
        label: "Seasonal holiday baskets",
        description: "Prepared with dedicated donors and volunteers to ensure holiday meals reach families across Brightwood and beyond.",
    },
    {
        value: "150+",
        label: "Families housed",
        description: "Supported by transitional housing and advocacy initiatives that open long-term pathways to stability.",
    },
];
const programHighlights = [
    {
        title: "Food Pantry & Weekend Backpack Program",
        summary: "Delivering nutritious groceries and 1,100+ annual backpack meals through volunteer-led distribution and partnerships with regional food banks.",
    },
    {
        title: "Housing Counseling & Transitional Support",
        summary: "Coordinating with housing counselors to prevent foreclosure, strengthen renter rights, and expand transitional housing pathways for more than 150 families to date.",
    },
    {
        title: "Community Revitalization & Clean Teams",
        summary: "Investing in corridor beautification, collaborative development, and neighborhood stewardship initiatives that keep Ward 4 vibrant.",
    },
    {
        title: "Immigration Advocacy & Legal Navigation",
        summary: "Connecting neighbors with trusted legal partners for free services that defend against deportation and support residency pathways.",
    },
];
const partnerHighlights = [
    {
        title: "Coordinated food access",
        description: "Weekly pantry distributions and the Weekend Backpack Program ensure children and families have consistent access to healthy food.",
    },
    {
        title: "Housing and economic resilience",
        description: "Transitional housing, financial coaching, and business corridor support expand long-term stability resources for families and entrepreneurs.",
    },
    {
        title: "Community-wide engagement",
        description: "Neighborhood clean teams, community walks, and volunteer drives mobilize more than 1,000 supporters to invest in Brightwood.",
    },
];
const HomePage = () => {
    return (_jsxs("div", { className: "relative isolate", children: [_jsx(HeroSection, { eyebrow: "Community-led support across Washington, D.C.", title: `Building hope with ${BUSINESS_NAME}`, subtitle: BUSINESS_DESCRIPTION, description: "We design food security, housing stability, and economic mobility initiatives that serve the Brightwood community and the greater Washington, D.C. region.", primaryCta: { label: "Partner with us", href: `mailto:${EMAIL}` }, secondaryCta: {
                    label: "Discover our programs",
                    href: "#programs",
                } }), _jsx(MissionSection, { mission: missionStatement, focusAreas: focusAreas }), _jsx(PartnerSpotlight, { name: "Community Partner Network", link: `mailto:${EMAIL}?subject=Community%20Partnership`, isExternal: false, summary: "Life Missions International convenes a coalition of neighbors, nonprofits, faith communities, and civic leaders to deliver programs that span the full life cycle of community needs\u2014from food access and housing to immigration services and small business support.", highlights: partnerHighlights, cta: {
                    label: "Start a partnership conversation",
                    href: `mailto:${EMAIL}?subject=Community%20Partnership`,
                    isExternal: false,
                } }), _jsx(ImpactStats, { id: "impact", stats: impactStats }), _jsx(ProgramsCarousel, { id: "programs", programs: programHighlights }), _jsx(CallToActionBanner, { title: "Help us accelerate community-centered initiatives", body: "Your investment powers weekly pantry operations, transitional housing, immigration advocacy, and neighborhood revitalization efforts that uplift thousands across Washington, D.C.", primaryCta: {
                    label: "Support Life Missions International",
                    href: `mailto:${EMAIL}?subject=Support%20Inquiry`,
                }, secondaryCta: {
                    label: "Connect with our team",
                    href: `mailto:${EMAIL}`,
                } })] }));
};
export default HomePage;
